module.exports = __webpack_public_path__ + "static/media/DSC_7111.eecb6572.jpg";